import React from "react";
import {
  FiHome,
  FiLayers,
  FiBookOpen,
  FiFileText,
  FiShield,
  FiMail,
  FiMapPin,
  FiPhone,
  FiExternalLink,
} from "react-icons/fi";
import { FaXTwitter, FaDiscord, FaYoutube } from "react-icons/fa6";

const deeporbUrl = new URL('../assets/logo64.png', import.meta.url).href;

export default function DeepOrbFooter({config}) {
  const year = new Date().getFullYear();

  const docsUrl = config?.docsUrl || "https://docs.deeporb.xyz";

  const coreLinks = [
    { label: "Overview", href: config?.docsUrl, icon: <FiHome className="h-4 w-4" /> },
    { label: "REST APIs", href: config?.docsUrl+"/guides/metricsapi/", icon: <FiBookOpen className="h-4 w-4" /> },
    { label: "EVM Oracles", href: config?.docsUrl+"/guides/evmoracles/", icon: <FiLayers className="h-4 w-4" /> },
    { label: "MCP Connectors", href: config?.docsUrl+"/guides/mcp/", icon: <FiExternalLink className="h-4 w-4" /> },
  ];

  const legalLinks = [
    { label: "Privacy Policy", href: config?.docsUrl+"/notices/privacy/", icon: <FiShield className="h-4 w-4" /> },
    { label: "Terms of Service", href: config?.docsUrl+"/notices/tos/", icon: <FiFileText className="h-4 w-4" /> },
  ];

  return (
    <footer className="relative w-full text-slate-300">
      {/* top gradient wash */}
      <div
        aria-hidden="true"
        className="absolute inset-x-0 -top-8 h-12"
      />
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-12">
        {/* Grid of cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {/* Company / Logo card */}
          <article className="justify-self-start items-startw-full text-left">
            <div className="flex items-center gap-3">
              <DeepOrbLogo className="h-8 w-8" />
              <h3 className="text-lg font-semibold mt-2 text-gray-300">DeepOrb Labs</h3>
            </div>
            <p className="mt-3 text-sm text-slate-400">
              DeepOrb Labs is an innovation studio for what's next in Cloud Automation, DeFi, and AI agents.
            </p>
            <p className="mt-4 text-xs text-slate-500">
              © {year} DeepOrb Labs LLC. All rights reserved.
            </p>
          </article>

          {/* Explore (Core site links) */}
          {/* <article className="justify-self-start items-startw-full text-left">
            <h3 className="text-lg font-semibold text-gray-300">Docs</h3>
            <ul className="mt-4 space-y-3">
              {coreLinks.map((l) => (
                <li key={l.label}>
                  <a
                    href={l.href}
                    className="group inline-flex items-center gap-2 text-sm text-slate-300 hover:text-cyan-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-cyan-400 rounded px-1 py-0.5"
                  >
                    <span className="text-cyan-300/80">{l.icon}</span>
                    <span>{l.label}</span>
                  </a>
                </li>
              ))}
            </ul>
          </article> */}

          {/* Legal */}
          <article className="justify-self-start items-startw-full text-left">
            <h3 className="text-lg font-semibold text-gray-300">Legal</h3>
            <ul className="mt-4 space-y-3">
              {legalLinks.map((l) => (
                <li key={l.label}>
                  <a
                    href={l.href}
                    className="group inline-flex items-start gap-2 text-sm text-slate-300 hover:text-purple-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-purple-400 rounded px-1 py-0.5"
                  >
                    <span className="text-purple-300/80">{l.icon}</span>
                    <span>{l.label}</span>
                  </a>
                </li>
              ))}
            </ul>
          </article>

          {/* Contact */}
          <article className="justify-self-start items-startw-full text-left">
            <h3 className="text-lg font-semibold text-gray-300">Contact</h3>
            <ul className="mt-4 space-y-3 text-sm">
              <li className="flex items-center gap-2">
                <FiMail className="h-4 w-4 text-cyan-300" />
                <a
                  className="hover:text-cyan-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-cyan-400 rounded px-1"
                  href="mailto:info@deeporblabs.com"
                >
                  info@deeporblabs.com
                </a>
              </li>
              {/* <li className="flex items-start gap-2">
                <FiMapPin className="mt-0.5 h-4 w-4 text-cyan-300" />
                <span className="text-slate-400">
                  Remote-first • Global
                </span>
              </li> */}
            </ul>
          </article>

          {/* Social */}
          <article className="justify-self-start items-startw-full text-left">
            <h3 className="text-lg font-semibold text-gray-300">Social</h3>
            <div className="mt-4 flex flex-wrap gap-3">
              <a
                href="https://x.com/OrbDeep"
                target="_blank"
                rel="noreferrer"
                aria-label="DeepOrb on X"
                className="inline-flex items-center gap-2 rounded-xl border border-cyan-500/30 bg-cyan-500/10 px-3 py-2 text-sm text-cyan-300 hover:bg-cyan-500/20 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-cyan-400"
              >
                <FaXTwitter className="h-4 w-4" />
                X
              </a>
              {/* <a
                href="https://discord.gg/deeporb"
                target="_blank"
                rel="noreferrer"
                aria-label="DeepOrb on Discord"
                className="inline-flex items-center gap-2 rounded-xl border border-purple-500/30 bg-purple-500/10 px-3 py-2 text-sm text-purple-300 hover:bg-purple-500/20 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-purple-400"
              >
                <FaDiscord className="h-4 w-4" />
                Discord
              </a> */}
              {/* <a
                href="https://www.youtube.com/@deeporblabs"
                target="_blank"
                rel="noreferrer"
                aria-label="DeepOrb on YouTube"
                className="inline-flex items-center gap-2 rounded-xl border border-red-500/30 bg-purple-500/10 px-3 py-2 text-sm text-red-300 hover:bg-red-500/20 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-red-400 hover:!text-red-500"
              >
                <FaYoutube className="h-4 w-4" />
                YouTube
              </a> */}
            </div>
            <p className="mt-4 text-xs text-slate-500">
              Follow updates, releases, and integration tips.
            </p>
          </article>
        </div>

        {/* Divider + bottom row
        <div className="mt-10 h-px w-full bg-gradient-to-r from-transparent via-cyan-500/30 to-transparent" />
        <div className="mt-6 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-slate-500">
          <div className="flex items-center gap-2">
            <DeepOrbLogo className="h-5 w-5" />
            <span>DeepOrb • Real-world aware data</span>
          </div>
          <div className="flex items-center gap-4">
            <a href="/privacy" className="hover:text-cyan-300">Privacy</a>
            <a href="/terms" className="hover:text-cyan-300">Terms</a>
            <a href="/contact" className="hover:text-cyan-300">Contact</a>
          </div>
        </div> */}

      </div>
    </footer>
  );
}

/** Minimal inline logo matching cyan/purple theme */
function DeepOrbLogo({ className = "h-8 w-8" }) {
  return (
    <img src={deeporbUrl} alt="Deeporb Logo" className={className} />
  );
}
